// dependencies
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// api
import { addUserToSelectionObject, fetchSelectionObjectCount, removeUserFromSelectionObject } from "../../services";
import { PYUseMutationOptions } from "../StandardQueryArguments";

export const useSelectionObjectCount = (selectionObjectID: string) => {
	return useQuery({
		queryKey: ["selectionObjectCount", selectionObjectID],
		queryFn: () => fetchSelectionObjectCount(selectionObjectID),
		meta: {
			errorMessage: "There was an error getting the selection object count.",
		},
	});
};

export const useMutateAddUserToSelectionObject = (selectionObjectID: string, options?: PYUseMutationOptions) => {
	const client = useQueryClient();

	return useMutation({
		mutationKey: ["selectionObjectAddUser"],
		mutationFn: ({ userIDs }: { userIDs: string[] }) => addUserToSelectionObject(selectionObjectID, userIDs),
		...options,
		onSuccess: (data, variables, context) => {
			options?.onSuccess && options.onSuccess(data, variables, context);
			client.invalidateQueries({ queryKey: ["employeesWithSelectionObject"] });
		},
	});
};

export const useMutateRemoveUserFromSelectionObject = (selectionObjectID: string, options?: PYUseMutationOptions) => {
	const client = useQueryClient();

	return useMutation({
		mutationKey: ["selectionObjectRemoveUser"],
		mutationFn: ({ userIDs }: { userIDs: string[] }) => removeUserFromSelectionObject(selectionObjectID, userIDs),
		...options,
		onSuccess: (data, variables, context) => {
			options?.onSuccess && options.onSuccess(data, variables, context);
			client.invalidateQueries({ queryKey: ["employeesWithSelectionObject"] });
		},
	});
};
